module.exports = __webpack_public_path__ + "img/logo.8ecc6933.png";